import executeApi from './executeApi';
import { fetchAuthSession } from 'aws-amplify/auth';
import { SystemError } from "../../constants";

/** セッションチェック */
const sessionCheck = async (
  screenId: string,
  action: string
) => {
  // 認証
  const session = await fetchAuthSession();
  const email = session.tokens?.idToken?.payload?.email;
  const sessionId = session.tokens?.idToken?.payload?.sessionId;
  const jwtToken = session.tokens?.idToken?.toString();
  // EyesFrontAPIのURLを取得
  const baseURL = process.env.REACT_APP_EYES_FRONT_API_ROOT!;
  // セッション確認API PATH
  const path = "/auth/session/execution";
  const request = {
    "mailAddress": email,
    "sessionId": sessionId,
    "screenAndActionId": screenId + "_" + action
  };

  try {
    const response = await executeApi(baseURL, path, jwtToken, 0, request);
    // レスポンスコード返却
    if (!response || response.data.resCd == "") {
      return SystemError
    } else {
      return response.data.resCd
    }
  } catch (e) {
    return SystemError;
  }
};

export default sessionCheck;